'use client';
import { CloseButton, createTheme } from '@mantine/core';
import { Icon } from '@iconify/react';
import { Loader } from '@mantine/core';
import Image from 'next/image';

export const themeProvider = {
    // Font sizes
    fontSizes: {
        xl: 'var(--fs-xl)',
        lg: 'var(--fs-lg)',
        md: 'var(--fs-md)',
        base: 'var(--fs-base)',
        sm: 'var(--fs-sm)',
        xs: 'var(--fs-xs)',
        xxs: 'var(--fs-xxs)',
    },

    // Colors
    colors: {
        customPrimary: ['var(--primary-light)', 'var(--primary-dark)'],
    },

    // Components
    components: {
        Container: {
            defaultProps: {
                size: 'md',
            },
            styles: {
                root: {
                    maxWidth: '110rem',
                },
            },
        },
    },
};

export const customThemeProvider = createTheme({
    primaryColor: 'gold',

    colors: {
        // Add your color
        gold: ['#b79661', '#b79661', '#b79661', '#b79661', '#b79661', '#b79661', '#b79661', '#b79661', '#b79661', '#b79661'],
    },

    breakpoints: {
        smallest: '20rem',
        xxs: '23.75em', // 23.75rem
        xs: '30em', // 30rem
        sm: '36em', // 36rem
        md: '48em', // 48rem
        lg: '62em', // 62rem
        xl: '75em', // 75rem
        xxl: '85em', // 85rem
        xvl: '87.5em', // 87.5rem
        vvl: '100em', // 100rem
    },
});

// Icons
export const selectDropdownIcon = <Icon icon="icon-park-outline:down" fontSize="1.25rem" color="var(--dark-gray-color)" />;
export const addUserIcon = <Icon icon="bx:user-plus" fontSize="1.25rem" />;
export const editIcon = <Icon icon="ic:round-edit" fontSize="1.125rem" />;
export const plusIcon = <Icon icon="ic:round-plus" fontSize="1.125rem" />;
export const minusIcon = <Icon icon="ic:round-minus" fontSize="1.125rem" />;
export const infoIcon = <Icon icon="clarity:help-info-solid" fontSize="1rem" />;
export const keyIcon = <Icon icon="ri:key-2-line" fontSize="1.25rem" />;
export const lockIcon = <Icon icon="bxs:lock" fontSize="1.125rem" />;
export const unlockIcon = <Icon icon="wpf:unlock-2" fontSize="1.125rem" />;

export const screenIcon = <Icon icon="foundation:monitor" fontSize="1.125rem" />;
export const withdrawIcon = <Icon icon="ph:hand-withdraw-bold" fontSize="1.25rem" />;
export const depositIcon = <Icon icon="ph:hand-deposit-bold" fontSize="1.25rem" />;
export const transactionIcon = <Image src="/images/icons/player-transactions.svg"width="20" height="20" style={{width: "1.25rem", height: "1.25rem"}}  alt="Player Transactions" />;
export const gameHistoryIcon = <Image src="/images/icons/game-history.svg"width="20" height="20" style={{width: "1.25rem", height: "1.25rem"}}  alt="Game History" />;
export const warnIcon = <Icon icon="material-symbols:info-outline-rounded" fontSize="1.125rem" />;
export const pendingIcon = <Icon icon="material-symbols:pending-outline" fontSize="1.125rem" />;
export const cancelIcon = <Icon icon="material-symbols:cancel-outline-rounded" fontSize="1.125rem" />;
export const winIcon = <Icon icon="famicons:checkmark-done-circle-outline" fontSize="1.125rem" />;
export const CloseIcon = ({ onClick }) => <Icon onClick={onClick} className="cursor-pointer" icon="ic:twotone-clear" fontSize="1.25rem" />;

export const messageIcon = <Icon icon="mage:message-dots-round-fill" fontSize="1.125rem" />;

export const SiteLoader = ({ size = 16, ...props }) => <Loader color="black" size={size} {...props} />;
export const SelectClose = ({ onClick }) => <CloseButton onMouseDown={(event) => event.preventDefault()} onClick={onClick} size="md" />;
